/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { PropsWithChildren } from "react";

import FullScreen from "@mui/icons-material/Fullscreen";
import FullScreenExit from "@mui/icons-material/FullscreenExit";
import { Divider, IconButton, Stack, Tab, Tabs, Toolbar, Typography } from "@mui/material";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";

interface ITableToolbarProps extends PropsWithChildren {
  isFullScreen: boolean;
  setFullScreen: () => void;
  tabs?: {
    value: "general" | "monthly_view";
    onChange: (value: "general" | "monthly_view") => void;
  };
}

export const TableToolbar: React.FC<ITableToolbarProps> = ({ isFullScreen, setFullScreen, tabs, children }) => {
  const { value: selectedTab } = tabs || {};

  return (
    <Toolbar sx={{ padding: "0px !important" }}>
      <Stack sx={{ flexGrow: 1 }}>
        <Stack sx={{ p: "16px 16px 0 16px", gap: "20px" }}>
          <Stack direction="row" sx={{ justifyContent: "space-between" }}>
            <Typography sx={{ fontSize: "20px", fontWeight: 500 }}>Portfolio Performance</Typography>
            <MaterialTooltip isShow title={"Toggle Expand"} placement="top">
              <IconButton sx={{ marginTop: "-5px" }} onClick={setFullScreen}>
                {isFullScreen ? <FullScreenExit /> : <FullScreen />}
              </IconButton>
            </MaterialTooltip>
          </Stack>
          {tabs && (
            <Tabs
              sx={{
                borderBottom: "1px solid #DBE8F5",
                minHeight: "auto",

                ".MuiTabs-flexContainer": {
                  gap: "16px",
                  alignItems: "center"
                },

                ".MuiTabs-indicator": {
                  bgcolor: "#071F35"
                },

                ".MuiTab-root": {
                  padding: "2px 0 6px 0",
                  minHeight: 24,
                  minWidth: "auto",
                  color: "#496682",
                  "&.Mui-selected": {
                    color: "#071F35"
                  }
                }
              }}
              value={tabs.value}
              onChange={(e, value) => tabs.onChange(value)}
            >
              <Tab key="general" value="general" label="General" />
              <Divider orientation="vertical" sx={{ width: "1px", height: 18, borderColor: "#DBE8F5" }} />
              <Tab key="monthly_view" value="monthly_view" label="Monthly View" />
            </Tabs>
          )}
        </Stack>
        <Stack
          padding="16px"
          flexDirection="row"
          justifyContent={selectedTab === "monthly_view" ? "flex-end" : "space-between"}
          width="100%"
          alignItems="center"
        >
          {children}
        </Stack>
      </Stack>
    </Toolbar>
  );
};
